define('vspot-angular/services/cookie-service',[], function () {
    'use strict';

    /*
     * NOTE: You probably don't want to use this service directly. The User
     * service has built-in cookie handlers for a user's cookies that handles
     * the JSON encoding/decoding and makes sure the variables are there.
     */

    return ['resources.Cookie', function (Cookie) {

        return {
            get: function (key) { 
                return Cookie.get({
                    id: key
                });
            },
            save: function (key, value, expires) {
                var params = {
                    key:    key,
                    value:  JSON.stringify(value)
                };

                if( expires !== undefined ) {
                    params.expires = expires;
                }

                return Cookie.save(params);
            },

            /* Delete one cookie
             *  @param {int} id - ID of the cookie to remove. Must be ID as that's the Rails restful way.
             */
            delete: function(id) {
                return Cookie.delete({
                    id:    id
                });
            },

            /*
             * deleteAll:
             * Remove all cookies for a user.
             */
            deleteAll: function() {
                return Cookie.deleteAll();
            }
        };
    }];
});

